import React from "react";
import { Close } from "react-ionicons";

export default function Pane(params) {
    let removeEntry = function () {
        params.changeStateData((ele) => {
            let demoArray = [...params.stateData.mapPoints];
            demoArray.splice(params.index, 1);
            let returnData = {
                ...ele,
                mapPoints: [...demoArray],
            };
            localStorage.setItem("stateData", JSON.stringify(returnData));
            return returnData;
        });
    };
    return (
        <div className="pane">
            <div className="coords">
                <span className="coords-text">{params.coords}</span>
            </div>
            <div className="note">
                <p className="note-text">{params.note}</p>
            </div>
            <div className="delete-button">
                <Close
                    color="red"
                    height="3rem"
                    width="3rem"
                    onClick={removeEntry}
                />
            </div>
        </div>
    );
}
